import {
  LOAD_FOLDER_LIST_SUCCESS,
  SAVE_FOLDER_ID,
  DELETE_FOLDER,
} from "constants/ActionTypes";

const INIT_STATE = {
  myFolderList: [],
  update:false,
  selectedFolderID: localStorage.getItem('folder_id'),
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case LOAD_FOLDER_LIST_SUCCESS: {
      return {
        ...state,
        update:false,
        myFolderList: action.payload
      }
    }
    case SAVE_FOLDER_ID: {
       return {
        ...state,
        selectedFolderID: action.payload
      }
    }
    case DELETE_FOLDER: {

      return{
        ...state,
        update:true
      }
    }

    default: {// need this for default case
      return state
    }

  }

}
